import { getErrorInstance } from '@principle-theorem/shared';

export function injectScript(
  id: string,
  src: string,
  type: string = 'text/javascript',
  isAsync: boolean = true,
  override: boolean = false
): Promise<void> {
  return new Promise((resolve, reject) => {
    const existing = document.getElementById(id);
    if (existing && !override) {
      resolve();
      return;
    }
    if (existing && override) {
      existing.remove();
    }

    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.type = type;
    script.async = isAsync;
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', (e) => reject(getErrorInstance(e.error)));
    document.head.appendChild(script);
  });
}

export function injectStylesheet(id: string, href: string): void {
  if (document.getElementById(id)) {
    return;
  }
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}
